var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stack"},[_c('div',{staticClass:"card"},[_c('router-link',{staticClass:"banner-link",attrs:{"to":{ name:'HowToPage' }}},[_c('img',{attrs:{"src":"/images/howto.jpg","alt":"boatnaviの使い方"}})])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"right_access_ranking"}},[_c('div',{attrs:{"id":"boat-ranking"}})])
}]

export { render, staticRenderFns }